import React from "react";

const StatusBadge = ({ status, language, t, translations }) => {
  const translate =
    typeof t === "function"
      ? t
      : (key) =>
          translations?.[language]?.[key] ??
          translations?.en?.[key] ??
          key;

  const statusStyles = {
    paid: { bg: "#d1fae5", color: "#065f46", text: translate("paid") },
    pending: { bg: "#fef3c7", color: "#92400e", text: translate("pending") },
    approved: { bg: "#dbeafe", color: "#1e40af", text: translate("approved") },
    rejected: { bg: "#fee2e2", color: "#991b1b", text: translate("rejected") },
  };

  const style = statusStyles[status] || statusStyles.pending;

  return (
    <span
      style={{
        padding: "0.25rem 0.625rem",
        borderRadius: "0.5rem",
        fontSize: "0.75rem",
        fontWeight: "600",
        backgroundColor: style.bg,
        color: style.color,
        display: "inline-block",
      }}
    >
      {style.text}
    </span>
  );
};

export default StatusBadge;